import { OverlayBadgeDesignTokens } from '@primeuix/themes/types/overlaybadge';
import { type SemanticTokens, SEMANTIC } from '../tokens/semantic.js';

/**
 * OverlayBadge Component Configuration
 * Controls the outline that separates an overlaid badge from its host component.
 */
export function createOverlaybadge(s: SemanticTokens): OverlayBadgeDesignTokens {
  return {
    root: {
      outline: {
        width: '2px',
        color: s.surface.ground,
      },
    },
  };
}

export const overlaybadge = createOverlaybadge(SEMANTIC);
